module.exports = __webpack_public_path__ + "img/vue.4c038d52.png";